import React, {forwardRef, useState} from 'react';
import {useFormikContext, useField} from 'formik';
import {Container, InputField, InputLabel} from './styles';
import {theme} from '../../../styles/darkTheme';
//@ts-ignore
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ErrorMessage from '../FormField/ErrorMessage';
import {hasKey} from '../../../utils/getters';
import Header from './Header';

interface Props {
  type: string;
  label: string;
  placeholder: string;
  name: string;
}

const DateField: React.FC<Props> = ({label, placeholder, name, type}) => {
  const {setFieldTouched, errors, touched, setFieldValue} = useFormikContext();
  const [field] = useField(name);

  const getError = () => {
    if (hasKey(errors, name)) {
      // @ts-ignore
      return errors[name];
    }
    return null;
  };

  const getTouched = () => {
    if (hasKey(touched, name)) {
      // @ts-ignore
      return touched[name];
    }
    return false;
  };

  return (
    <Container>
      <InputLabel theme={theme}>{label}</InputLabel>
      <DatePicker
        {...field}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(date: Date) => {
          setFieldValue(field.name, date);
        }}
        dateFormat="yyyy-MM-dd"
        placeholderText={placeholder}
        customInput={
          <InputField
            onBlur={() => setFieldTouched(name)}
            type={type}
            placeholder={placeholder}
            theme={theme}
          />
        }
        renderCustomHeader={({
          //@ts-ignore
          date,
          //@ts-ignore
          changeYear,
          //@ts-ignore
          changeMonth,
          //@ts-ignore
          decreaseMonth,
          //@ts-ignore
          increaseMonth,
          //@ts-ignore
          prevMonthButtonDisabled,
          //@ts-ignore
          nextMonthButtonDisabled,
        }) => (
          <Header
            date={date}
            changeYear={changeYear}
            changeMonth={changeMonth}
            decreaseMonth={decreaseMonth}
            increaseMonth={increaseMonth}
            prevMonthButtonDisabled={prevMonthButtonDisabled}
            nextMonthButtonDisabled={nextMonthButtonDisabled}
          />
        )}
      />
      <ErrorMessage error={getError()} visible={getTouched()} />
    </Container>
  );
};

export default DateField;
